
import React, { useEffect, useRef, useState } from 'react';
import { EditPageHeader } from './EditPageHeader';
import { Grid, GRID_COL_INDEX_ATTRIBUTE, GridColumn } from '@progress/kendo-react-grid';
import { DropdownCell, SingleDropDownCell } from '../framework/forms/helpercomponents/CustomGridCells/DropdownCell';
import * as API from "../framework/API/api";
import { utility } from '../framework/utility/utilityProvider';
import { COLUMNSTYPE, ENTITYNAME, LOCALSTORAGE_KEY, MEDIA_TRANSMISSION, SYNOPSIS_TYPE, TOAST_TYPES } from '../framework/constant/constant';
import { CellRender, RowRender } from '../modules/Segment/renderers';
import { useTranslation } from '../locale/useTranslation';
import PreferenceRoundButton from '../framework/forms/helpercomponents/buttons/PreferenceRoundButton';
import { UserPreference } from '../modules/userPreference/UserPreference';
import { arrayEnumCell } from '../framework/forms/helpercomponents/CustomGridCells/PlatformCell';
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from '../framework/forms/helpercomponents/CustomGridCells/DateCell';
import MyStatusCell from './MyStatusCell';
import { ArrayCell } from '../framework/forms/helpercomponents/CustomGridCells/ArrayCell';
import { CheckboxCell } from '../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import { ImageCell } from '../framework/forms/helpercomponents/CustomGridCells/ImageCell';
import { Loader } from '../framework/forms/helpercomponents/Loader';
import { getter, Icon } from '@progress/kendo-react-common';
import { myTimeCellMilliseconds } from '../framework/forms/helpercomponents/inline grid cell/MyTimeCellInMillisconds';
import BossDialog from './BossDialog';
import { getSelectedState, useTableKeyboardNavigation } from '@progress/kendo-react-data-tools';
import { MediaMamAssetColumns } from '../framework/utility/customColumns';
import CollectionSelection from '../framework/forms/CollectionSelection';
import { TimePickerWithFormat } from '../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import MyMultiSelect from './MyMultiSelect';
import { ConfirmAlert } from '../ConfirmAlert';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import SaveButton from '../framework/forms/helpercomponents/buttons/SaveButton';
import ToastNotification from './ToastNotification';

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const EDIT_FIELD = 'inEdit';
const idGetter = getter(DATA_ITEM_KEY);

const UpdateMultipleEpisodeDialog = (props) => {

    const { selectedEpisode, setSelectedEpisode, refresh, closeForm } = props;

    const [updatedDataItemIds, setUpdatedDataItemIds] = useState([]);
    const [genres, setGenres] = useState([]);
    const [language, setLanguage] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [pgRatings, setPgRatings] = useState([]);
    const [categories, setCategories] = useState([]);
    const [castTypes, setCastTypes] = useState([]);
    const seletedEpisodeRef = useRef([]);

    const lang = useTranslation();
    const [showPreferences, setShowPreferences] = useState(false);
    const [showMamAssetCollectionSelection, setShowMamAssetCollection] = useState(false);
    const [dataColumns, setDataColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedState, setSelectedState] = useState({});
    const blankDataItem = {
        Title: "",
        EpisodeTitle: "",
        Duration: "00:00:00:00",
        Genres: [],
        SubGenres: [],
        Synopsis: "",
        CustomTitle1: "",
        CustomTitle2: "",
        CustomEpisodeTitle1: "",
        CustomEpisodeTitle2: "",
        ShortTitle: "",
        CustomShortTitle: "",
        Description: "",
        CustomDescription: "",
        Provider: {},
        Studio: "",
        originCountries: "",
        imageUrl1: "",
        imageUrl2: ""
    };
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [isEdit, setIsEdit] = useState(false);
    const [showBulkDrawer, setShowBulkDrawer] = useState(false);
    const [providers, setProviders] = useState([]);

    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const isRock = company.Name && company?.Name?.toLowerCase() == "rock"
    const isEncompass = company.Name && company.Name.toLowerCase() == "encompass"

    const blankDynamicFieldObj = {}

    const blankExtensionObj = {
        Studio: "",
        originCountries: "",
        imageUrl1: "",
        imageUrl2: ""
    }

    const selectedCount = Object.values(selectedState).filter(Boolean).length;

    useEffect(() => {
        loadCombo();
        loadMetaData();
        loadColumns();
    }, []);

    useEffect(() => {
        if (selectedCount > 1) {
            setShowBulkDrawer(true);
        } else {
            setShowBulkDrawer(false);
        }
    }, [selectedCount]);

    const loadColumns = async () => {
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columns = await API.getFormData(ENTITYNAME.MediaEpisodeMultiEdit, currentUserId) ?? [];
        setDataColumns(columns);
    }

    const loadCombo = async () => {
        let genreRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        setGenres(genreRes.data);
        let languagesRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
        setLanguages(languagesRes.data);
        let pgRatingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
        setPgRatings(pgRatingRes.data);
        let categoriesRes = await API.getDataLookup(ENTITYNAME.ContentCategory, { sort: { Name: 1 } });
        setCategories(categoriesRes.data);
        let castTypeRes = await API.getDataLookup(ENTITYNAME.CastType, { sort: { Description: 1 }, query: ["Archive", "!=", true] });
        setCastTypes(castTypeRes.data);
        let providerRes = await API.getDataLookup(ENTITYNAME.OttProvider, { sort: { Description: 1 }, query: ["Archive", "!=", true] });
        setProviders(providerRes.data);
    }

    const setCastAndCrewData = (metaData) => {

        let castAndCrewObj = {};

        let tempCastAndCrew = metaData.CastAndCrew.reduce((acc, curr) => {
            const castType = curr.CastType.Description;
            const language = curr.Language.Description;

            if (!acc[castType]) {
                acc[castType] = {};
            }

            if (!acc[castType][language]) {
                acc[castType][language] = [];
            }

            acc[castType][language].push(curr.Name);

            return acc;
        }, {});

        Object.keys(tempCastAndCrew).map((castType) => {
            Object.keys(tempCastAndCrew[castType]).map((language) => {
                if (language == "English") {
                    castAndCrewObj[castType] = tempCastAndCrew[castType][language].join(', ');
                } else {
                    castAndCrewObj[`${language}${castType}`] = tempCastAndCrew[castType][language].join(', ');
                }
            })
        })

        return castAndCrewObj;

    }

    const loadMetaData = async () => {
        setIsLoading(true);
        let defaultLang = null;
        if (selectedEpisode.length > 0) {
            let langRes = await API.getData(ENTITYNAME.Language);
            if (langRes.success && langRes.data.length > 0) {
                defaultLang = utility.getDefaultItem(langRes.data);
                setLanguage(defaultLang);
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Couldn\'t get default language' });
                multipleUpdateFormClose();
                return;
            }
            let res = await API.getMetaDataFromMediaEpisode(selectedEpisode.map(x => x.SID));
            if (res.success) {
                const metaData = res.data;
                setSelectedEpisode(
                    selectedEpisode.map(x => {
                        let metaDataAttached = metaData?.find(m => m.MediaEpisodeSID == x.SID);
                        if (metaDataAttached) {
                            let synop = metaDataAttached.Synopsis && Array.isArray(metaDataAttached.Synopsis) && metaDataAttached.Synopsis?.find(s => s?.Language?._id == defaultLang._id);
                            let chsynop = metaDataAttached.Synopsis && Array.isArray(metaDataAttached.Synopsis) && metaDataAttached.Synopsis?.find(s => s?.Language?.Description == "Chinese");
                            let spsynop = metaDataAttached.Synopsis && Array.isArray(metaDataAttached.Synopsis) && metaDataAttached.Synopsis?.find(s => s?.Language?.Description == "Spanish");
                            let mdsynop = metaDataAttached.Synopsis && Array.isArray(metaDataAttached.Synopsis) && metaDataAttached.Synopsis?.find(s => s?.Language?.Description == "Mandarin");
                            if (synop || chsynop || spsynop || mdsynop) {
                                let item = {
                                    ...x,
                                    MediaEpisode_id: metaDataAttached.MediaEpisode_id,
                                    MediaEpisodeSID: metaDataAttached.MediaEpisodeSID,
                                    metaDataId: metaDataAttached._id,
                                    Synopsis: metaDataAttached.Synopsis,
                                    ChineseSynopsis: chsynop?.Synopsis,
                                    SpanishSynopsis: spsynop?.Synopsis,
                                    MandarinSynopsis: mdsynop?.Synopsis,
                                    synopsis: synop?.Synopsis,
                                    dynamicField: metaDataAttached.dynamicField,
                                    CastAndCrew: metaDataAttached.CastAndCrew,
                                    PGRating: metaDataAttached.PGRating,
                                    ProductionYear: metaDataAttached.ProductionYear,
                                    Languages: metaDataAttached.Languages,
                                    Categories: metaDataAttached.Categories,
                                    MamID: metaDataAttached.MamID ?? "",
                                    Extension: metaDataAttached.Extension ?? {}
                                }

                                //CAST & CREW HANDLING
                                if (metaDataAttached.CastAndCrew && metaDataAttached.CastAndCrew.length > 0) {

                                    let castAndCrewData = setCastAndCrewData(metaDataAttached);
                                    item = { ...item, ...castAndCrewData }

                                }
                                delete item.CastAndCrew

                                return item;
                            } else {
                                let obj = {
                                    ...x,
                                    MediaEpisode_id: metaDataAttached.MediaEpisode_id,
                                    MediaEpisodeSID: metaDataAttached.MediaEpisodeSID,
                                    metaDataId: metaDataAttached._id,
                                    Synopsis: [],
                                    synopsis: "",
                                    dynamicField: metaDataAttached.dynamicField,
                                    CastAndCrew: metaDataAttached.CastAndCrew,
                                    PGRating: metaDataAttached.PGRating,
                                    ProductionYear: metaDataAttached.ProductionYear,
                                    Languages: metaDataAttached.Languages,
                                    Categories: metaDataAttached.Categories,
                                    MamID: metaDataAttached.MamID ?? "",
                                    Extension: metaDataAttached.Extension ?? {}
                                }

                                //CAST & CREW HANDLING
                                if (metaDataAttached.CastAndCrew && metaDataAttached.CastAndCrew.length > 0) {
                                    let castAndCrewData = setCastAndCrewData(metaDataAttached);
                                    obj = { ...obj, ...castAndCrewData }
                                }
                                delete obj.CastAndCrew
                                return obj;
                            }
                        }
                        return { ...x, MediaEpisode_id: x.SID, MediaEpisodeSID: x.SID, metaDataId: null, synopsis: "", dynamicField: {}, Languages: [], Categories: [], PGRating: {}, MamID: "" };
                    })
                );
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
                multipleUpdateFormClose();
            }
        }
        setIsLoading(false);
    }

    const multipleUpdateFormClose = () => {
        closeForm();
        setUpdatedDataItemIds([]);
    }

    const enterEdit = (dataItem, field) => {
        const newData = selectedEpisode.map(item => ({
            ...item,
            [EDIT_FIELD]: (item._id == dataItem._id && item.Sequence === dataItem.Sequence) ? field : undefined
        }));
        setSelectedEpisode(newData);
    };

    const exitEdit = () => {
        const newData = selectedEpisode.map(item => ({
            ...item,
            [EDIT_FIELD]: undefined
        }));
        setSelectedEpisode(newData);
    };

    const customCellRender = (td, props) => <CellRender originalProps={props} td={td} enterEdit={enterEdit} editField={EDIT_FIELD} />;

    const customRowRender = (tr, props) => <RowRender originalProps={props} tr={tr} exitEdit={exitEdit} editField={EDIT_FIELD} />;

    const itemChange = (event) => {
        let field = event.field || '';
        if (field == 'Duration') {
            event.dataItem[field] = utility.convertStringWithFramesToMilliseconds(event.value);
        } else {
            if (field.includes('.')) {
                let keys = field.split('.');
                keys.length == 2 ? event.dataItem[keys[0]][keys[1]] = event.value : event.dataItem[keys[0]] = event.value
            } else {
                event.dataItem[field] = event.value;
            }
        }

        let newData = selectedEpisode.map(item => {
            if (item._id === event.dataItem._id) {
                return event.dataItem;
            }
            return item;
        });

        if (!updatedDataItemIds.includes(event.dataItem._id)) {
            setUpdatedDataItemIds([...updatedDataItemIds, event.dataItem._id]);
        }
        setSelectedEpisode(newData);
    };

    const handleMultipleUpdateSave = async () => {

        if (updatedDataItemIds.length == 0) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Nothing to update' });
        } else {
            // DELETE UN-WANTED KEY FROM DATA BEFORE SENDING TO API
            let dataToUpdate = selectedEpisode.filter(x => updatedDataItemIds.includes(x._id)).map(d => {

                let item = { ...d };

                //REMOVE METADATA KEYS
                delete item[EDIT_FIELD];
                delete item.metaDataId;
                delete item.MediaEpisode_id;
                delete item.MediaEpisodeSID;
                delete item.synopsis;
                delete item.Synopsis;
                delete item.ChineseSynopsis;
                delete item.SpanishSynopsis;
                delete item.MandarinSynopsis;
                delete item.dynamicField;
                delete item.Extension;
                if (item.CastAndCrew && item.CastAndCrew.length > 0) {
                    item.CastAndCrew.map((y) => {
                        delete item[y.CastType.Description];
                    })
                }
                delete item.CastAndCrew;
                delete item.Languages;
                delete item.PGRating;
                delete item.ProductionYear;
                delete item.Categories;
                delete item.MamID;

                return item;
            });

            // send data in chunks of 50 to api
            for (let i = 0; i < dataToUpdate.length; i += 50) {
                let media = dataToUpdate.slice(i, i + 50);
                let res = await API.bulkUpdate(ENTITYNAME.MediaEpisode, media);
                if (!res.success) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message ?? 'Some data not updated' });
                    setUpdatedDataItemIds(updatedDataItemIds.filter(x => !media.map(x => x._id).includes(x)));
                }
            }
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Data updated successfully' });
        }
        await handleMultipleEditMetaData();
    }

    const handleMultipleEditMetaData = async () => {

        if (updatedDataItemIds.length == 0) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Nothing to update' });
        } else {

            let dataToUpdate = selectedEpisode.filter(x => updatedDataItemIds.includes(x._id)).map(d => {

                let prevSynopsis = d.Synopsis?.filter((s) => s.Language._id != language._id && s.Language.Description != "Chinese" && s.Language.Description != "Spanish" && s.Language.Description != "Mandarin" && s.Type == SYNOPSIS_TYPE.Long);

                let otherSynopsis = [];

                //DEFAULT LANG SYNOPSIS
                if (d.synopsis?.length > 0) {
                    otherSynopsis.push({ Synopsis: d.synopsis, Language: language, Type: SYNOPSIS_TYPE.Long });
                }
                //CHINESE SYNOPSIS
                if (d.ChineseSynopsis?.length > 0) {
                    otherSynopsis.push({ Synopsis: d.ChineseSynopsis, Language: languages?.find(x => x.Description == "Chinese"), Type: SYNOPSIS_TYPE.Long });
                }
                //SPANISH SYNOPSIS
                if (d.SpanishSynopsis?.length > 0) {
                    otherSynopsis.push({ Synopsis: d.SpanishSynopsis, Language: languages?.find(x => x.Description == "Spanish"), Type: SYNOPSIS_TYPE.Long });
                }
                //MANDARIN SYNOPSIS
                if (d.MandarinSynopsis?.length > 0) {
                    otherSynopsis.push({ Synopsis: d.MandarinSynopsis, Language: languages?.find(x => x.Description == "Mandarin"), Type: SYNOPSIS_TYPE.Long });
                }

                const synopsisArr = prevSynopsis?.length > 0 ? [...prevSynopsis, ...otherSynopsis] : otherSynopsis;


                let castAndCrew = [];
                //Handle Cast and Crew Saving Data
                if (d && Object.keys(d).length > 0) {

                    Object.keys(d).forEach((key) => {
                        const value = d[key];
                        if (!value || !value.length) return;

                        const castType = castTypes.find(ct => key.endsWith(ct.Description));
                        if (!castType) return;

                        let langDesc = key.slice(0, key.length - castType.Description.length).trim();

                        let language = languages?.find(
                            l => l.Description.toLowerCase() === (langDesc || "english").toLowerCase()
                        ) || { Description: "English" };

                        const index = castAndCrew.findIndex(x =>
                            x.CastType.Description === castType.Description &&
                            x.Language?.Description === language.Description
                        );

                        if (index > -1) {
                            castAndCrew[index].Name = value;
                        } else {
                            castAndCrew.push({
                                CastType: {
                                    _id: castType._id,
                                    Description: castType.Description
                                },
                                Name: value,
                                Language: language
                            });
                        }
                    });
                }

                return {
                    _id: d.metaDataId,
                    MediaEpisode_id: d.MediaEpisode_id,
                    MediaEpisodeSID: d.MediaEpisodeSID,
                    Synopsis: synopsisArr,
                    dynamicField: d.dynamicField,
                    Extension: d.Extension,
                    CastAndCrew: castAndCrew,
                    ProductionYear: d.ProductionYear ?? '',
                    Languages: d.Languages && d.Languages.length > 0 ? d.Languages.map(x => { return { ...x, Description: x.Description, ISOCode: x.ISOCode } }) : [],
                    PGRating: d.PGRating && Object.keys(d.PGRating).length > 0 ? { _id: d.PGRating._id, Description: d.PGRating.Description } : {},
                    Categories: d.Categories && d.Categories.length > 0 ? d.Categories.map(x => { return { _id: x._id, Name: x.Name } }) : [],
                    MamID: d.MamID ?? '',
                };

            });

            // send data in chunks of 50 to api
            for (let i = 0; i < dataToUpdate.length; i += 50) {
                let media = dataToUpdate.slice(i, i + 50);
                let res = await API.bulkUpdate(ENTITYNAME.MediaEpisodeMetaData, media);
                if (!res.success) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message ?? 'Some data not updated' });
                    setUpdatedDataItemIds(updatedDataItemIds.filter(x => !media.map(x => x._id).includes(x)));
                }
            }

            //CALL SYNC MAM ID FUNCTION
            let mediaData = selectedEpisode.filter((x) => updatedDataItemIds.includes(x._id)).filter((x) => x.MamID && x?.MamID?.toString().length > 0).map((z) => ({ MamID: z.MamID, AssetId: z.AssetId }));
            console.log(mediaData)
            await onSyncMAMAsset(mediaData);

            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Meta Data updated successfully' });
        }
        onClose();
    }

    const onMultiDropDownChange = (event, dataItem, field, textField = "Description", textField2 = null) => {
        setSelectedEpisode(selectedEpisode.map(x => x._id == dataItem._id ? { ...x, [field]: event.value.map(e => (textField2 ? { _id: e._id, [textField]: e?.[textField], [textField2]: e?.[textField2] } : { _id: e._id, [textField]: e?.[textField] })) } : x));
        if (!updatedDataItemIds.includes(dataItem._id)) {
            setUpdatedDataItemIds([...updatedDataItemIds, dataItem._id]);
        }
    }

    let timeOut;
    const handleColumnResize = (event) => {
        try {
            if (event.index == 0) return;
            if (dataColumns == undefined || dataColumns.length == 0 || dataColumns.length < event.index) return;

            let column = dataColumns[event.index];
            let payload = {
                entityName: column?.entityName,
                name: column?.name,
                width: event.newWidth
            };
            clearTimeout(timeOut);
            timeOut = setTimeout(() => {
                API.updateUserPreferenceColumnWidth(payload);
            }, 700);
        } catch (error) {
            console.error("Error handling column resize:", error);
        }
    };

    const onDropDownChange = (event, dataItem, field, onlyID = false) => {
        const selected = event.value;
        setSelectedEpisode((prev) => prev.map((x) => x._id === dataItem._id ? { ...x, [field]: onlyID ? selected._id : { _id: selected._id, Description: selected.Description } } : x));
        if (!updatedDataItemIds.includes(dataItem._id)) { setUpdatedDataItemIds((prev) => [...prev, dataItem._id]); }
    };

    const MyMultiSelectDropDown = (props) => {

        const field = props.field || '';
        let data = [];
        let onChange = (e) => { onMultiDropDownChange(e, props.dataItem, field) }
        let textField = "Description";

        if (field == "Genres" || field == "SubGenres") {
            data = genres;
        } else if (field == "Languages") {
            data = languages;
            onChange = (e) => { onMultiDropDownChange(e, props.dataItem, field, textField, "ISOCode") }
        } else if (field == "Categories") {
            data = categories;
            textField = "Name"
            onChange = (e) => { onMultiDropDownChange(e, props.dataItem, field, "Name") }
        } else {
            data = genres
        }

        return <DropdownCell {...props} data={data} onChange={onChange} textField={textField} />

    }

    const MySingleSelectDropDown = (props) => {

        const field = props.field || '';

        let data = [];
        let matchById = false;
        let textField = "Description";
        let onChange = (e) => {
            onDropDownChange(e, props.dataItem, field)
        }

        if (field == "Transmission") {
            data = Object.keys(MEDIA_TRANSMISSION).map((x) => ({ _id: MEDIA_TRANSMISSION[x], Description: x }))
            onChange = (e) => { onDropDownChange(e, props.dataItem, field, true) }
            matchById = true;
        } else if (field == "MediaType" || field == "MediaSubType") {
            data = genres
        } else if (field == "PGRating") {
            data = pgRatings
        } else if (field == "Provider") {
            data = providers
        }

        return <SingleDropDownCell {...props} data={data} onChange={onChange} matchById={matchById} textField={textField} />
    }

    //SYNC MAM ASSET 
    const onBrowseMamAsset = (datalist) => {
        console.log("BROWSE MAM");
        setSelectedEpisode(selectedEpisode.map(x => x._id == seletedEpisodeRef.current._id ? { ...x, MamID: datalist[0]?.RawData?.id?.toString() } : x));
        if (!updatedDataItemIds.includes(seletedEpisodeRef.current._id)) {
            setUpdatedDataItemIds([...updatedDataItemIds, seletedEpisodeRef.current._id]);
        }
    }

    const onSyncMAMAsset = async (mediaData) => {

        console.log(mediaData)

        if (!mediaData || mediaData.length == 0) return;

        let finalData = mediaData.map(x => ({ MamID: x.MamID, AssetId: x.AssetId }))

        const payload = { isSyncMultipleMedia: true, data: finalData, MamID: null, AssetId: null }

        console.log(payload)

        //CALL SYNC API HERE
        const reponse = await API.syncMediaManagement(payload)

        if (!reponse.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: reponse.message });
            return;
        }
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: reponse.message });

    }

    const MamIDCell = (props) => {

        const field = props.field;
        const value = props?.dataItem?.[field] ?? '';

        return <td
            colSpan={props.colSpan}
            role={"gridcell"}
            aria-colindex={props.ariaColumnIndex}
            aria-selected={props.isSelected}
            {...{
                [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
            }}
            {...useTableKeyboardNavigation(props.id)}
            style={props.style}
        >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <input
                    type="text"
                    className="form-control form-control-sm"
                    name="MamID"
                    value={value}
                    onChange={() => { }}
                    disabled
                    required
                />

                <button placeholder="Attach MAM Asset" title="Attach MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                    style={{ height: "30px" }} onClick={() => { setShowMamAssetCollection(true); seletedEpisodeRef.current = props.dataItem }}><i className="fa-solid fa-ellipsis fa-xs"></i>
                </button>
                {/* <button placeholder="Sync MAM Asset" title="Sync MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
              style={{ height: "30px" }} onClick={onSyncMAMAsset}><i className="fa-solid fa-sync fa-xs"></i>
            </button> */}
                <button placeholder="Detach MAM Asset" title="Detach MAM Asset" type="button" className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-error"
                    style={{ height: "30px" }} onClick={() => {
                        setSelectedEpisode(selectedEpisode.map(x => x._id == props.dataItem._id ? { ...x, MamID: "" } : x));
                        if (!updatedDataItemIds.includes(props.dataItem._id)) {
                            setUpdatedDataItemIds([...updatedDataItemIds, props.dataItem._id]);
                        }
                    }}><i className="fa-solid fa-xmark"></i>
                </button>
            </div>
        </td>
    }

    const onSelectionChange = (event) => {

        // ignore row click selection -- THIS IS FOR CHECKBOX ONLY ( It re-render the row and unale to edit row and dropdowns stopped working too )
        const fromCheckbox = event.syntheticEvent?.target?.closest?.('input[type="checkbox"]');
        if (!fromCheckbox) {
            return;
        }
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);

        let selectedIds = Object.keys(newSelectedState);
        let tempSelected = [];

        selectedIds.map((value) => {
            if (newSelectedState[value]) {
                let filter = selectedEpisode.find((obj) => obj._id == value);
                tempSelected.push(filter);
            }
        });
        seletedEpisodeRef.current = tempSelected;
        setUpdatedDataItemIds(tempSelected.map(x => x._id));
    };

    const onHeaderSelectionChange = (event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);

        var selectedIds = Object.keys(newSelectedState);
        var tempSelected = [];

        if (checked) {
            selectedIds.map((value) => {
                if (newSelectedState[value]) {
                    var filtered = selectedEpisode.find((obj) => obj._id == value);
                    tempSelected.push(filtered);
                }
            });
        }
        seletedEpisodeRef.current = tempSelected;
        setUpdatedDataItemIds(tempSelected.map(x => x._id));
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    }

    const handleUpdateAll = async () => {
        setIsEdit(true);
        if (seletedEpisodeRef.current.length == 0) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Please select at least one episode' });
            return;
        }

        let dataToUpdate = seletedEpisodeRef.current.map(d => {

            //FOR DYNAMIC FIELDS UPDATE ALL
            let updatedDynamicField = d.dynamicField || {};
            let updatedExtensionField = d.Extension || {};

            const dynamicFieldObj = d.dynamicField && Object.keys(d.dynamicField).length > 0 ? { ...blankDynamicFieldObj, ...d.dynamicField } : blankDynamicFieldObj;
            Object.keys(dynamicFieldObj).forEach((key) => {
                if (dataItem[key] && dataItem[key] !== "") {
                    updatedDynamicField[key] = dataItem[key];
                }
            });

            const extensionObj = d.Extension && Object.keys(d.Extension).length > 0 ? { ...blankExtensionObj, ...d.Extension } : blankExtensionObj;
            Object.keys(extensionObj).forEach((key) => {
                if (dataItem[key] && dataItem[key] !== "") {
                    updatedExtensionField[key] = dataItem[key];
                }
            });

            return {
                ...d,
                Title: (dataItem.Title && dataItem.Title != "") ? dataItem.Title : d.Title,
                EpisodeTitle: (dataItem.EpisodeTitle && dataItem.EpisodeTitle != "") ? dataItem.EpisodeTitle : d.EpisodeTitle,
                Duration: (dataItem.Duration && dataItem.Duration != "" && dataItem.Duration != "00:00:00:00") ? utility.convertStringWithFramesToMilliseconds(dataItem.Duration) : d.Duration,
                Genres: (dataItem.Genres && dataItem.Genres.length > 0) ? dataItem.Genres : d.Genres,
                SubGenres: (dataItem.SubGenres && dataItem.SubGenres.length > 0) ? dataItem.SubGenres : d.SubGenres,
                synopsis: (dataItem.Synopsis && dataItem.Synopsis != "") ? dataItem.Synopsis : d.synopsis,
                MediaType: (dataItem.MediaType && dataItem.MediaType._id != 0) ? dataItem.MediaType : d.MediaType,
                MediaSubType: (dataItem.MediaSubType && dataItem.MediaSubType._id != 0) ? dataItem.MediaSubType : d.MediaSubType,
                ChineseSynopsis: (dataItem.ChineseSynopsis && dataItem.ChineseSynopsis != "") ? dataItem.ChineseSynopsis : d.ChineseSynopsis,
                MandarinSynopsis: (dataItem.MandarinSynopsis && dataItem.MandarinSynopsis != "") ? dataItem.MandarinSynopsis : d.MandarinSynopsis,
                PGRating: (dataItem.PGRating && dataItem.PGRating._id != 0) ? dataItem.PGRating : d.PGRating,
                Cast: (dataItem.Cast && dataItem.Cast.length > 0) ? dataItem.Cast : d.Cast,
                Director: (dataItem.Director && dataItem.Director.length > 0) ? dataItem.Director : d.Director,
                ProductionYear: (dataItem.ProductionYear && dataItem.ProductionYear != "") ? dataItem.ProductionYear : d.ProductionYear,
                ChineseCast: (dataItem.ChineseCast && dataItem.ChineseCast.length > 0) ? dataItem.ChineseCast : d.ChineseCast,
                dynamicField: updatedDynamicField,
                Extension: updatedExtensionField,
                CustomTitle: {
                    Title1: dataItem.CustomTitle1 ? dataItem.CustomTitle1 : d?.CustomTitle?.Title1 || "",
                    Title2: dataItem.CustomTitle2 ? dataItem.CustomTitle2 : d?.CustomTitle?.Title2 || ""
                },
                CustomEpisodeTitle: {
                    Title1: dataItem.CustomEpisodeTitle1 ? dataItem.CustomEpisodeTitle1 : d?.CustomEpisodeTitle?.Title1 || "",
                    Title2: dataItem.CustomEpisodeTitle2 ? dataItem.CustomEpisodeTitle2 : d?.CustomEpisodeTitle?.Title2 || ""
                },
                ShortTitle: dataItem.ShortTitle ? dataItem.ShortTitle : d?.ShortTitle || "",
                CustomShortTitle: dataItem.CustomShortTitle ? dataItem.CustomShortTitle : d?.CustomShortTitle || "",
                Description: dataItem.Description ? dataItem.Description : d?.Description || "",
                CustomDescription: dataItem.CustomDescription ? dataItem.CustomDescription : d?.CustomDescription || "",
                Provider: dataItem?.Provider?._id ? { _id: dataItem?.Provider?._id, Description: dataItem?.Provider?.Description } : d?.Provider ?? {}
            }
        });
        //Update grid data 
        const updatedSelectedEpisodes = selectedEpisode.map(original => {
            const updated = dataToUpdate.find(updatedItem => updatedItem._id === original._id);
            return updated ? updated : original;
        });
        seletedEpisodeRef.current = updatedSelectedEpisodes;
        setSelectedEpisode(updatedSelectedEpisodes);
        setSelectedState({});
        setDataItem(blankDataItem);
    }

    const onClose = () => {
        seletedEpisodeRef.current = [];
        setUpdatedDataItemIds([]);
        setSelectedState({});
        setDataItem(blankDataItem);
        setIsEdit(false);
        setShowBulkDrawer(false);
        refresh();
        multipleUpdateFormClose();
    }

    let labelStyle = { fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: '#3A3633' };
    return (
        <BossDialog title={'Update multiple'} onClose={() => isEdit ? ConfirmAlert(() => onClose(), () => { }, "Discard changes", "Are you sure you want to discard the changes?") : onClose()} width="90%" height="90%">
            <div className="flex-container">
                <div className='mt-2 mb-2'>
                    <EditPageHeader title={""} onSubmit={handleMultipleUpdateSave} onCancel={() => isEdit ? ConfirmAlert(() => onClose(), () => { }, "Discard changes", "Are you sure you want to discard the changes?") : onClose()} showTitle={false} />
                </div>
                <div className="flex-container-reverse flex-item-auto mt-2" style={{ gap: '8px' }}>
                    {selectedCount > 1 && (
                        <button
                            type="button"
                            className="btn btn-default btn-circle btn-my"
                            title={showBulkDrawer ? 'Hide bulk edit' : 'Show bulk edit'}
                            onClick={() => setShowBulkDrawer((prev) => !prev)}
                            style={{ margin: "0px 01px" }}
                        >
                            <i className={`fa-solid fa img-circle fa-fw  ${showBulkDrawer ? 'fa-solid fa-xmark' : 'fa-chevron-left'}`}></i>
                        </button>
                    )}
                    <PreferenceRoundButton
                        icon="gear"
                        title={lang.preference_button_tooltip}
                        onClick={() => { setShowPreferences(true) }}
                    />
                </div>
            </div>
            <div style={{ position: 'relative' }}>
                {isLoading ? <Loader /> :
                    <Grid
                        data={
                            selectedEpisode.map((item) => ({
                                ...item,
                                [SELECTED_FIELD]: selectedState[idGetter(item)],
                            }))}
                        style={{
                            height: "calc(90vh - 160px)",
                            width: selectedCount > 1 && showBulkDrawer ? "calc(100% - 430px)" : "100%",
                            overflow: "auto",
                            transition: 'width 0.2s ease'
                        }}
                        editField={EDIT_FIELD}
                        cellRender={customCellRender}
                        rowRender={customRowRender}
                        onItemChange={itemChange}
                        resizable={true}
                        onColumnResize={handleColumnResize}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: true,
                            drag: false,
                            cell: false,
                            mode: "multiple",
                        }}
                        dataItemKey={DATA_ITEM_KEY}
                        onSelectionChange={onSelectionChange}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                    >
                        <GridColumn
                            field={SELECTED_FIELD}
                            width="50px"
                            headerSelectionValue={
                                selectedEpisode.findIndex(
                                    (item) => !selectedState[idGetter(item)]
                                ) === -1
                            }
                            locked={true}
                            filterable={false}
                        />
                        {dataColumns.map((column, index) => {
                            const titleWithIcon = column.editable ? (
                                <span>
                                    {column.label} <Icon style={{ fontSize: '10px' }} name="pencil" />
                                </span>
                            ) : column.label;

                            if (column.type === COLUMNSTYPE.date) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={DateOnlyCell}
                                        title={titleWithIcon}
                                        width={column.width ?? 200}
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.datetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={DateCell}
                                        title={titleWithIcon}
                                        width={column.width ?? 200}
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            }
                            else if (column.name.includes("Duration")) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={myTimeCellMilliseconds}
                                        title={titleWithIcon}
                                        width={column.width ?? 200}
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            } else if (column.name === "SID") {
                                return;
                            } else if (column.type === COLUMNSTYPE.image) {
                                return (
                                    <GridColumn
                                        sortable={false}
                                        key={index}
                                        field={column.name}
                                        cell={ImageCell}
                                        title={titleWithIcon}
                                        width={column.width ?? 100}
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.checkbox) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={CheckboxCell}
                                        title={titleWithIcon}
                                        width={column.width ?? 80}
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.array) {
                                return (
                                    <GridColumn
                                        sortable={false}
                                        key={index}
                                        field={column.name}
                                        cell={ArrayCell}
                                        title={titleWithIcon}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"} //display item in object
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.status) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyStatusCell}
                                        title={titleWithIcon}
                                        width={column.width ?? 200}
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.localdatetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={LocalDateTimeColumn}
                                        title={titleWithIcon}
                                        width={column.width ?? 200}
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.arrayenum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={arrayEnumCell}
                                        title={titleWithIcon}
                                        width={column.width ?? 80}
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.multiselectdropdown) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={(props) => <MyMultiSelectDropDown {...props} />}
                                        title={titleWithIcon}
                                        width={column.width ?? 80}
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.singleselectdropdown) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={(props) => (<MySingleSelectDropDown {...props} />)}
                                        title={titleWithIcon}
                                        width={column.width ?? 80}
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.mamIDCell) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MamIDCell}
                                        title={titleWithIcon}
                                        width={column.width ?? 80}
                                        editable={column.editable}
                                        locked={index === 0 ? true : false}
                                    />
                                );
                            }
                            else {
                                return (
                                    column.type !== COLUMNSTYPE.hidden && (
                                        <GridColumn
                                            key={index}
                                            field={column.name}
                                            title={titleWithIcon}
                                            width={column.width ?? 200}
                                            editable={column.editable}
                                            locked={index === 0 ? true : false}
                                        />
                                    )
                                );
                            }
                        })}
                    </Grid>}

                {selectedCount > 1 && showBulkDrawer && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            height: 'calc(90vh - 160px)',
                            width: '420px',
                            background: '#fff',
                            borderLeft: '1px solid #dee2e6',
                            boxShadow: '-8px 0 20px rgba(0, 0, 0, 0.08)',
                            display: 'flex',
                            flexDirection: 'column',
                            zIndex: 3
                        }}
                    >
                        <div style={{ padding: '12px 14px', borderBottom: '1px solid #e9ecef' }}>
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h6 className="mb-1">Update selected episodes</h6>
                                    <small className="text-muted">Fill only fields to apply to all selected items.</small>
                                </div>
                                <SaveButton btnColor="success" title="Update All" onClick={handleUpdateAll} />
                            </div>
                        </div>

                        <div style={{ padding: '14px', overflowY: 'auto' }}>
                            <div style={{ display: 'grid', gap: '12px', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.title_label}</label>
                                    <input type="text" name="Title" className="form-control form-control-sm" placeholder="Title" value={dataItem.Title} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{isRock ? lang.chinese_title_label : lang.custom_title_1_label}</label>
                                    <input type="text" name="CustomTitle1" className="form-control form-control-sm" placeholder={isRock ? lang.chinese_title_label : lang.custom_title_1_label} value={dataItem.CustomTitle1} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{isRock ? lang.spanish_title_label : lang.custom_title_2_label}</label>
                                    <input type="text" name="CustomTitle2" className="form-control form-control-sm" placeholder={isRock ? lang.spanish_title_label : lang.custom_title_2_label} value={dataItem.CustomTitle2} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.episode_title_label}</label>
                                    <input type="text" name="EpisodeTitle" className="form-control form-control-sm" placeholder="Episode Title" value={dataItem.EpisodeTitle} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{isRock ? lang.chinese_episode_title_label : lang.custom_episode_title_1_label}</label>
                                    <input type="text" name="CustomEpisodeTitle1" className="form-control form-control-sm" placeholder={isRock ? lang.chinese_episode_title_label : lang.custom_episode_title_1_label} value={dataItem.CustomEpisodeTitle1} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{isRock ? lang.spanish_episode_title_label : lang.custom_episode_title_2_label}</label>
                                    <input type="text" name="CustomEpisodeTitle2" className="form-control form-control-sm" placeholder={isRock ? lang.spanish_episode_title_label : lang.custom_episode_title_2_label} value={dataItem.CustomEpisodeTitle2} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.short_title_label}</label>
                                    <input type="text" name="ShortTitle" className="form-control form-control-sm" placeholder="Short Title" value={dataItem.ShortTitle} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.custom_short_title_label}</label>
                                    <input type="text" name="CustomShortTitle" className="form-control form-control-sm" placeholder="Custom Short Title" value={dataItem.CustomShortTitle} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.description_label}</label>
                                    <input type="text" name="Description" className="form-control form-control-sm" placeholder="Description" value={dataItem.Description} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.custom_description_label}</label>
                                    <input type="text" name="CustomDescription" className="form-control form-control-sm" placeholder="Custom Description" value={dataItem.CustomDescription} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.duration_without_format_label}</label>
                                    <TimePickerWithFormat className="form-control form-control-sm" name="Duration" value={dataItem.Duration} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.synopsis_label}</label>
                                    <input type="text" name="Synopsis" className="form-control form-control-sm" placeholder="Synopsis" value={dataItem.Synopsis} onChange={onChange} />
                                </div>

                                {isRock && (
                                    <div>
                                        <label style={labelStyle} className="form-label">{lang.chinese_synopsis_label}</label>
                                        <input type="text" name="ChineseSynopsis" className="form-control form-control-sm" placeholder="Chinese Synopsis" value={dataItem.ChineseSynopsis} onChange={onChange} />
                                    </div>
                                )}
                                {isEncompass && (
                                    <div>
                                        <label style={labelStyle} className="form-label">{lang.mandarin_synopsis_label ?? "Mandarin Synopsis"}</label>
                                        <input type="text" name="MandarinSynopsis" className="form-control form-control-sm" placeholder="Mandarin Synopsis" value={dataItem.MandarinSynopsis} onChange={onChange} />
                                    </div>
                                )}
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.geners_label}</label>
                                    <MyMultiSelect
                                        data={genres}
                                        name="Genres"
                                        dataItemKey="_id"
                                        style={{ width: "100%" }}
                                        textField="Description"
                                        value={dataItem.Genres}
                                        onChange={onChange}
                                    />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.sub_geners_label}</label>
                                    <MyMultiSelect
                                        data={genres}
                                        name="SubGenres"
                                        dataItemKey="_id"
                                        style={{ width: "100%" }}
                                        textField="Description"
                                        value={dataItem.SubGenres}
                                        onChange={onChange}
                                    />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.provider_label}</label>
                                    <DropDownList
                                        data={providers}
                                        name="Provider"
                                        dataItemKey="_id"
                                        style={{ width: "100%" }}
                                        textField="Description"
                                        value={dataItem.Provider}
                                        onChange={onChange}
                                    />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.pg_rating_label}</label>
                                    <DropDownList
                                        data={pgRatings}
                                        name="PGRating"
                                        dataItemKey="_id"
                                        style={{ width: "100%" }}
                                        textField="Description"
                                        value={dataItem.PGRating}
                                        onChange={onChange}
                                    />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.production_year_label}</label>
                                    <input type="text" name="ProductionYear" className="form-control form-control-sm" placeholder="Production Year" value={dataItem.ProductionYear} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.cast_column}</label>
                                    <input type="text" name="Cast" className="form-control form-control-sm" placeholder="Cast" value={dataItem.Cast} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.chinese_cast_label}</label>
                                    <input type="text" name="ChineseCast" className="form-control form-control-sm" placeholder="Chinese Cast" value={dataItem.ChineseCast} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.director_label}</label>
                                    <input type="text" name="Director" className="form-control form-control-sm" placeholder="Director" value={dataItem.Director} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.studio_label}</label>
                                    <input type="text" name="Studio" className="form-control form-control-sm" placeholder="Studio" value={dataItem.Studio} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{lang.origin_countries_label}</label>
                                    <input type="text" name="originCountries" className="form-control form-control-sm" placeholder="Origin Countries" value={dataItem.originCountries} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{`${lang.image_url1_label} ${isEncompass ? '(Landscape)' : ''}`}</label>
                                    <input type="text" name="imageUrl1" className="form-control form-control-sm" placeholder="imageUrl1" value={dataItem.imageUrl1} onChange={onChange} />
                                </div>
                                <div>
                                    <label style={labelStyle} className="form-label">{`${lang.image_url2_label} ${isEncompass ? '(Portrait)' : ''}`}</label>
                                    <input type="text" name="imageUrl2" className="form-control form-control-sm" placeholder="imageUrl2" value={dataItem.imageUrl2} onChange={onChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>


            {showPreferences && <UserPreference entityName={ENTITYNAME.MediaEpisodeMultiEdit} preferenceColumnENntityName={ENTITYNAME.MediaEpisodeMultiEdit} handleClose={() => { setShowPreferences(false); loadColumns(); }} />}
            {showMamAssetCollectionSelection && <CollectionSelection entityname={ENTITYNAME.MediaMamAssets} customColumns={MediaMamAssetColumns} title={lang.attach_mam_asset_tooltip} closeForm={() => setShowMamAssetCollection(false)} wherestatement={""} setDataList={onBrowseMamAsset} mode={"single"} width={"50vw"} />}

        </BossDialog>
    );
}

export default UpdateMultipleEpisodeDialog;